import { Injectable, inject } from '@angular/core';
import { MortgageApiService } from '@api-new/mortgageservice';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { getDashboardData, getDashboardDataFailure, getDashboardDataSuccess, loadInitialPlatformData } from '@shared/store/common.actions';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CommonEffects {
  private readonly mortgageApiService = inject(MortgageApiService);
  private readonly actions$ = inject(Actions);

  handleLoadInitialPlatformData = createEffect(() => this.actions$.pipe(ofType(loadInitialPlatformData), map(getDashboardData)));

  getDashboardData = createEffect(() =>
    this.actions$.pipe(
      ofType(getDashboardData),
      switchMap(() => this.mortgageApiService.HTTP_CP_GetDashboardData()),
      map((response) => getDashboardDataSuccess(response)),
      catchError((error) => of(getDashboardDataFailure({ error }))),
    ),
  );
}
